import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { State, Country, County } from '../_models/signups/geography';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';

const baseUrl = `${environment.apiUrl}/api/geography`;
@Injectable({
  providedIn: 'root'
})
export class GeographyService {

  constructor(private http: HttpClient) { }

  lookupState(postalCode: string): Observable<any> {
    return this.http.get<any>(`${baseUrl}/lookup-state?postalCode=${postalCode}`);
  }

  getStates() : Observable<State[]> {
    return this.http.get<State[]>(`${baseUrl}/get-states`);
  }

  getCountries() : Observable<Country[]> {
    return this.http.get<Country[]>(`${baseUrl}/get-countries`);
  }

  getStatesByPostalCode(postalCode: string) : Observable<any[]> {
    return this.http.get<any[]>(`${baseUrl}/get-states?postalCode=${postalCode}`);
  }

  getCounties(postalCode: string, stateCode: string) : Observable<County[]> {
    return this.http.get<County[]>(`${baseUrl}/get-counties?stateCode=${stateCode}&postalCode=${postalCode}`);
  }
}
